import { Title } from "@gamesheet/ui";
import * as Grid from "../layouts/GridItems";

export function EditTeamPage(){
    return (<>
        <Grid.Blank column={1} row={1}>
            <Title bartype="divider" text="Edit Team" size="h2"/>
        </Grid.Blank>
    </>)
}